import { ApplicantCallAction } from './applicantCallAction/ApplicantCallAction';
import BankDetailsAction from './bankDetailsAction/BankDetailsAction';
import { CommissionConsentAction } from './commissionConsentAction/CommissionConsentAction';
import DebitCardAction from './debitCardAction/DebitCardAction';
import IdCheckVerificationAction from './idCheckVerificationAction/IdCheckVerificationAction';
import MajorShareholderCheckAction from './majorShareholderCheckAction/MajorShareholderCheckAction';
import { TFundingRequirementsSteps } from './orderFundingRequirements';
import { PennyTransferAction } from './pennyTransferAction/PennyTransferAction';
import SignDocumentAction from './signDocumentAction/SignDocumentAction';
import { TSignDocument } from './signDocumentAction/SignDocumentsHelper';
import { UploadBankEvidenceAction } from './uploadBankEvidenceAction/UploadBankEvidenceAction';
import { UploadGewerbescheinAction } from './UploadGewerbescheinAction/UploadGewerbescheinAction';
import { WaitForOtherGuarantorsAction } from './waitForOtherGuarantorsAction/WaitForOtherGuarantorsAction';
import { FormalOffer } from '../../myOffers/MyOffers.types';

export const getStepItem = ({
    step,
    formalOffer,
    triggerRefetchFundingRequirements
}: {
    step: TFundingRequirementsSteps[number];
    formalOffer: FormalOffer;
    triggerRefetchFundingRequirements?: () => void;
}) => {
    const { product_type: productType } = formalOffer;
    const type = step.type.toUpperCase();
    switch (type) {
        case 'BANK_DETAILS':
            return (
                <BankDetailsAction
                    step={step}
                    formalOffer={formalOffer}
                    triggerRefetchFundingRequirements={
                        triggerRefetchFundingRequirements!
                    }
                />
            );
        case 'WAIT_FOR_OTHER_GUARANTORS':
            return <WaitForOtherGuarantorsAction step={step} />;
        case 'UPLOAD_GEWERBESCHEIN':
            return (
                <UploadGewerbescheinAction
                    status={step.status}
                    triggerRefetchFundingRequirements={
                        triggerRefetchFundingRequirements!
                    }
                />
            );
        case 'UPLOAD_BANK_EVIDENCE':
            return (
                <UploadBankEvidenceAction
                    status={step.status}
                    triggerRefetchFundingRequirements={
                        triggerRefetchFundingRequirements!
                    }
                />
            );
        case 'DEBIT_CARD':
            return <DebitCardAction status={step.status} />;
        case 'APPLICANT_CALL':
            return (
                <ApplicantCallAction
                    productType={productType}
                    status={step.status}
                />
            );
        case 'PENNY_TRANSFER':
            return (
                <PennyTransferAction
                    status={step.status}
                    triggerRefetchFundingRequirements={
                        triggerRefetchFundingRequirements!
                    }
                />
            );
        case 'ONFIDO_VIDEO_VERIFICATION':
        case 'ONFIDO_VERIFICATION':
        case 'IDVERSE_VERIFICATION':
            return <IdCheckVerificationAction status={step.status} />;
        case 'MAJOR_SHAREHOLDER_CHECK':
            return <MajorShareholderCheckAction status={step.status} />;
        case 'GUARANTEE':
        case 'MASTER_LOAN_AGREEMENT':
        case 'REASONABLE_EXPLANATION':
        case 'SECCI':
        case 'COMPANIES_HOUSE_CHARGE':
        case 'BUSINESS_INTERRUPTION_PAYMENT_OFFER_LETTER':
        case 'DATA_PROTECTION_DISCLOSURE_DECLARATION':
        case 'DATA_PROTECTION_DISCLOSURE_DECLARATION_GUARANTOR':
        case 'INFORMATION_DECLARATION':
        case 'REFINANCING_SIDE_LETTER':
            return <SignDocumentAction step={step as TSignDocument} />;
        case 'COMMISSION_CONSENT':
            return (
                <CommissionConsentAction
                    status={step.status}
                    formalOffer={formalOffer}
                    triggerRefetchFundingRequirements={
                        triggerRefetchFundingRequirements!
                    }
                />
            );
    }
};
